/**
 * Get Local Storage Item
 * Will return parsed if applicable
 * @param key
 * @returns {*}
 */
export function getLocalStorageItem (key) {
  let localStorageItem = localStorage.getItem(key)

  if (!localStorageItem) {
    return null
  }

  let parsedLsItem

  try {
    parsedLsItem = JSON.parse(localStorageItem)
  } catch (e) {
    parsedLsItem = localStorageItem
  }
  return parsedLsItem
}

/**
 * Get Page Size from Local Storage
 * @param id
 */
export function getPageSize (id) {
  const storage = getLocalStorageItem('pagination')

  if (!storage || !storage[id]) {
    return false
  }

  return storage[id]
}
